import circularBorder from '@/assets/icons/circular-border.svg'
import aboutBg from '@/assets/images/home/aboutus-background.jpg'
import { SectionTitle } from '@/components/SectionTitle'
import { pageMaxWidth, pageXPadding, pageYPadding } from '@/config'
import { Button } from '../Button'

export const AboutUs = () => {
  return (
    <section className={`${pageXPadding} ${pageYPadding}`}>
      <div
        className={`${pageMaxWidth} mx-auto flex flex-col items-center justify-center gap-y-[5px] md:flex-row  md:gap-x-[90px] lg:gap-x-[125px]`}
      >
        <div className="flex w-full justify-center  md:w-1/2">
          <div className="relative mb-[76px] inline-flex justify-center">
            <img
              className="absolute bottom-0 left-0 h-[152.68px] w-[148.35px] -translate-x-1/2 translate-y-1/2 md:size-[200px] lg:size-[284px]"
              src={circularBorder}
            />
            <img
              src={aboutBg}
              className="relative z-10 size-[221px] rounded-t-[50%] md:aspect-square md:size-[285px] md:h-auto md:w-full lg:size-[455px]"
            />
          </div>
        </div>
        <div className="flex w-full flex-col gap-y-[12px] font-nunito md:w-1/2">
          <h2 className="text-center text-[16px] font-[600] leading-[19.2px] text-[#333333] md:text-start md:text-[20px] md:leading-[24px]  lg:text-start lg:text-[24px]  lg:leading-[28.8px]">
            Licensed Interior Designer
          </h2>
          <div className="flex justify-center md:justify-start">
            <SectionTitle title="About Us" variant="primary" />
          </div>
          <p className="text-center text-[12px] font-[400] leading-[19.2px] text-[#000000] md:text-start md:text-[14px] md:leading-[22.4px] lg:text-start lg:text-[16px] lg:leading-[25.6px] ">
            We design interiors that are both functional and tailored to your
            needs. Our focus is on creating spaces that enhance your lifestyle,
            whether for your home or office. With a collaborative approach, we
            ensure every project reflects your vision and delivers lasting
            value.
          </p>
          <div className="flex justify-center gap-x-[10px] md:justify-start lg:justify-start">
            <Button>Learn More</Button>
            <Button>Portfolio</Button>
          </div>
        </div>
      </div>
    </section>
  )
}
